var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgFolderOpenR = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 5.5V7a.5.5 0 0 0 1 0V5.5c0-.414-.293-.707-.293-.707C12.914 4.5 12.5 4.5 12.5 4.5H8.169L6.43 3.2a1.123 1.123 0 0 0-.598-.2H2.5c-.414 0-.707.293-.707.293C1.5 3.586 1.5 4 1.5 4v9a.5.5 0 0 0 1 0V4h3.332L7.57 5.301c.266.198.599.199.599.199H12.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 13.5H2a.5.5 0 0 1-.474-.658l1.887-5.657s.1-.305.363-.495c0 0 .263-.19.587-.19h9.943s.24 0 .455.11c0 0 .214.109.355.304 0 0 .141.195.178.432 0 0 .037.238-.038.466l-1.782 5.346A.5.5 0 0 1 13 13.5Zm1.306-6-1.666 5H2.694l1.668-4.998V7.5h9.944Z",
  clipRule: "evenodd"
})));
const Memo = /*#__PURE__*/memo(SvgFolderOpenR);
export default Memo;